import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import CoverSection from "./components/CoverSection/CoverSection";
import Services from "./components/Services/Services";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <>
      <Navbar />
      <CoverSection />
      <Services />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
